
import {
  defineComponent,
  SetupContext,
  computed,
  ref,
  onMounted,
  onUnmounted
} from "vue";
import NativeClient, { TitleInfo } from "@/client/native-client";
import store from "@/store";
import {
  MenuCategories,
  PANTRY_ADD_CATEGORY_NAME_TYPE,
  PurChasedFoods,
  RankingFoods,
  FavoriteFoods,
  IngredientCategoryData,
  IngredientData,
  MenuCategory,
  FoodItem,
  RegisterFood,
  CandidateInfo,
  RecoginitionList,
  IngredientList,
  FridgeItemsJudge,
  FridgeItemsJudgeData,
  SelectingCandidateIngredientListDataItem,
  RequestRecognitionCandidateItem,
  SaveAddFoodItemData,
  SaveFridgeFoodItem,
  SaveFoodItem,
  SaveCategoryFoodItems,
  SaveGenreFoodItems,
  StatusCameraCheck,
  CHECK_SCREEN_STATUS,
  DEFALT_FOOD_ID,
  PANTRY_DEFAULT_STORAGE_TYPE
} from "@/types/pantry";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import SelectCategory from "@/components/common/SelectCategory.vue";
import PantryIngredientView from "@/components/pantry/PantryIngredientView.vue";
import PantryIngredientFoodListView from "@/components/pantry/PantryIngredientFoodListView.vue";
import PantryIngredientCameraListView from "@/components/pantry/PantryIngredientCameraListView.vue";
import PantryCameraCheckMainView from "@/components/pantry/PantryCameraCheckMainView.vue";
import PantryFoodSearchView from "@/components/pantry/PantryFoodSearchView.vue";
import CommonDesignDialog from "@/components/common/CommonDesignDialog.vue";
import { SelectingIngredientListDataItem } from "@/types/common";
import router from "@/router";
import DateUtil from "@/utils/date-util";
import PantryUtil from "@/utils/pantry-util";
export default defineComponent({
  name: "PantryAddPage",
  components: {
    SelectCategory,
    PantryIngredientView,
    PantryIngredientFoodListView,
    PantryIngredientCameraListView,
    PantryFoodSearchView,
    PantryCameraCheckMainView,
    CommonDesignDialog
  },
  props: {},
  setup(props, context: SetupContext) {
    const ERROR_BUTTON_LABEL = "OK";
    // 認識画像食材選択時のアニメーションタイマー(ms)
    const FOOD_TIMER = 1000;
    const categoryNameList = ref(Array<string>());
    const selectNo = ref(0);
    const selectCategoryName = ref(PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA);
    const recoginitionCheckList = ref(new IngredientList());
    const recoginitionList = ref(new RecoginitionList());
    const purChasedList = ref(Array<SelectingIngredientListDataItem>());
    const rankingList = ref(Array<SelectingIngredientListDataItem>());
    const favoriteList = ref(Array<SelectingIngredientListDataItem>());
    const foodList = ref(Array<IngredientCategoryData>());
    const isShowComplite = ref(false);
    const isShowFoodSearch = ref(false);
    const isShowCheckCamera = ref(false);
    const checkCameraFoodList = ref(Array<RequestRecognitionCandidateItem>());
    const checkCamereSelectPosition = ref(0);
    const checkFoodItem = ref(new FoodItem("", null,DEFALT_FOOD_ID, null));
    const isShowAddComplite = ref(false);
    const isFoodTimerExec = ref(false);
    const isShowCheckError = ref(false);
    const textInput = ref<HTMLInputElement>();
    // 食材認識中のテキスト入力時の食材
    let inputInferenceResultFoodId = DEFALT_FOOD_ID;
    const inputCandinateData = ref(new CandidateInfo());
    // カメラ専用の食材情報
    const fridgeItemsJudege = ref(new FridgeItemsJudgeData());
    let cameraApplianceId = "";
    // 検索ボタンタップ中
    let isInputMode = false;
    // 食材認識からの入力
    let isCameraInputMode = false;
    const keyword = ref("");
    const inputKeyword = ref("");
    const statusCheckScreen = ref(new StatusCameraCheck(-1, DEFALT_FOOD_ID, CHECK_SCREEN_STATUS.STATUS_NONE));
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();
    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();
    NativeClient.showCloseButton(true);
    NativeClient.setTitle(new TitleInfo(false, ""));
    /**
     * 検索キーワードを取得、設定する
     */
    const keywordComputed = computed({
      get: () => keyword.value,
      set: value => (keyword.value = value)
    });

    // 表示更新のためのリアクティブ
    const updateCategoryKey = ref(0);
    const updateCategory = () => {
      if (updateCategoryKey.value != 0) {
        updateCategoryKey.value = 0;
      } else {
        updateCategoryKey.value = 1;
      }
    };

    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value >= 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 表示更新のためのリアクティブ
    const updateCheckDisplayKey = ref(0);
    const updateCheckDisplay = () => {
      if (updateCheckDisplayKey.value >= 100) {
        updateCheckDisplayKey.value = 0;
      } else {
        updateCheckDisplayKey.value++;
      }
    };

    // 表示更新のためのリアクティブ
    const updateCameraListDisplayKey = ref(0);
    const updateCameraListDisplay = () => {
      if (updateCameraListDisplayKey.value >= 100) {
        updateCameraListDisplayKey.value = 0;
      } else {
        updateCameraListDisplayKey.value++;
      }
    };

    // 表示更新のためのリアクティブ
    const updateListCheckKey = ref(0);
    const updateListCheck = () => {
      if (updateListCheckKey.value >= 100) {
        updateListCheckKey.value = 0;
      } else {
        updateListCheckKey.value++;
      }
    };

    // 表示更新のためのリアクティブ
    const updateKeywordKey = ref(0);
    const updateKeyword = () => {
      if (updateKeywordKey.value >= 100) {
        updateKeywordKey.value = 0;
      } else {
        updateKeywordKey.value++;
      }
    };

    let checkTimerId = -1;
    const cancelCheckFoodTimer = () => {
      if (checkTimerId != -1) {
        clearTimeout(checkTimerId);
        checkTimerId = -1;
      }
    };
    const isSelectEmpty = () => {
      if (recoginitionCheckList.value.list != null && recoginitionCheckList.value.list.length != 0) {
        for (const item of recoginitionCheckList.value.list) {
          if (item.isSelect) {
            return false;
          }
        }
      }
      if (purChasedList.value.length != 0) {
        for (const item of purChasedList.value) {
          if (item.isSelect) {
            return false;
          }
        }
      }
      if (rankingList.value.length != 0) {
        for (const item of rankingList.value) {
          if (item.isSelect) {
            return false;
          }
        }
      }
      if (favoriteList.value.length != 0) {
        for (const item of favoriteList.value) {
          if (item.isSelect) {
            return false;
          }
        }
      }
      if (foodList.value.length != 0) {
        for (const category of foodList.value) {
          for (const itemA of category.list) {
            for (const itemB of itemA.list) {
              if (itemB.isSelect) {
                return false;
              }
            }
          }
        }
      }
      return true;
    };

    const isSelect = (name: string) => {
      NativeClient.sendDebugLog(
        "PantryAddPage isSelect name=" +
          name +
          " isSelect=" +
          selectCategoryName.value
      );
      const result = name == selectCategoryName.value;
      NativeClient.sendDebugLog(
        "PantryAddPage isSelect result=" +
          result +
          " name=" +
          name +
          " isSelect=" +
          selectCategoryName.value
      );
      return result;
    };

    const setPurChased = () => {
      const recipes: PurChasedFoods | null =
        store.getters["pantry/getPurChasedFoods"];
      const saveFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"];
      NativeClient.sendDebugLog("PantryAddPage setPurChased recipes=" + JSON.stringify(recipes));
      if (recipes && recipes.foods) {
        const list = Array<SelectingIngredientListDataItem>();
        recipes.foods.forEach(item => {
          const food = new SelectingIngredientListDataItem();
          food.id = item.foodId;
          food.imageUrl = item.iconUrl;
          food.name = item.name;
          food.isSelect = false;
          if (saveFoodItems != null) {
            const saveFoodItem = saveFoodItems.getPurChasedItem(food.id);
            if (saveFoodItem != null) {
              food.isSelect = true;
            }
          }
          list.push(food);
        });
        purChasedList.value = list;
      }
    };

    const requestPurChased = async () => {
      NativeClient.sendDebugLog("PantryAddPage requestPurChased");
      const recipes: PurChasedFoods | null =
        store.getters["pantry/getPurChasedFoods"];
      if (recipes != null) {
        setPurChased();
        return;
      }
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/getPurChasedFoods")]).then(
          result => {
            setPurChased();
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const setRanking = () => {
      const recipes: RankingFoods | null =
        store.getters["pantry/getRankingFoods"];
      const saveFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"];
      NativeClient.sendDebugLog("PantryAddPage setRanking recipes=" + JSON.stringify(recipes));
      if (recipes && recipes.foods) {
        const list = Array<SelectingIngredientListDataItem>();
        recipes.foods.forEach(item => {
          const food = new SelectingIngredientListDataItem();
          food.id = item.foodId;
          food.imageUrl = item.icon;
          food.name = item.name;
          food.isSelect = false;
          if (saveFoodItems != null) {
            const saveFoodItem = saveFoodItems.getRankingItem(food.id);
            if (saveFoodItem != null) {
              food.isSelect = true;
            }
          }
          list.push(food);
        });
        rankingList.value = list;
      }
    };

    const requestRanking = async () => {
      NativeClient.sendDebugLog("PantryAddPage requestRanking");
      const recipes: RankingFoods | null =
        store.getters["pantry/getRankingFoods"];
      if (recipes != null) {
        setRanking();
        return;
      }
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/getRankingFoods")]).then(
          result => {
            setRanking();
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const setFavorite = () => {
      const recipes: FavoriteFoods | null =
        store.getters["pantry/getFavoriteFoods"];
      const saveFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"];
      NativeClient.sendDebugLog("PantryAddPage setFavorite recipes=" + JSON.stringify(recipes));
      if (recipes && recipes.foods) {
        const list = Array<SelectingIngredientListDataItem>();
        recipes.foods.forEach(item => {
          const food = new SelectingIngredientListDataItem();
          food.id = item.foodId;
          food.imageUrl = item.icon;
          food.name = item.name;
          food.isSelect = false;
          if (saveFoodItems != null) {
            const saveFoodItem = saveFoodItems.getFavoriteItem(food.id);
            if (saveFoodItem != null) {
              food.isSelect = true;
            }
          }
          list.push(food);
        });
        favoriteList.value = list;
      }
    };

    const requestFavorite = async () => {
      NativeClient.sendDebugLog("PantryAddPage requestFavorite");
      const recipes: FavoriteFoods | null =
        store.getters["pantry/getFavoriteFoods"];
      if (recipes != null) {
        setFavorite();
        return;
      }
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([store.dispatch("pantry/getFavoriteFoods")]).then(
          result => {
            setFavorite();
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const setSelectIngredient = (list: Array<SelectingIngredientListDataItem>, id: number, isSelect: boolean) => {
      let result = false;
      let i = 0;
      for (const item of list) {
        if (item.id == id) {
          item.isSelect = isSelect;
          list[i] = item;
          result = true;
          break;
        }
        i++;
      }
      return result;
    };

    const selectIngredientFood = (category: string, id: number, isSelect: boolean) => {
      for (const categoryItem of foodList.value) {
        if (categoryItem.categoryName == category) {
          for (const categoryData of categoryItem.list) {
            const result = setSelectIngredient(categoryData.list, id, isSelect);
            if (result) {
              break;
            }
          }
          break;
        }
      }
      for (const category of foodList.value) {
        for (const item of category.list) {
          NativeClient.sendDebugLog(
            "PantryAddPage selectIngredientFood2 item=" + JSON.stringify(item)
          );
        }
      }
    };

    const onSelectIngredient = (category: string, id: number, name:string, isSelect: boolean) => {
      NativeClient.sendDebugLog(
        "PantryAddPage onSelectIngredient id=" +
          category +
          ", ingredientId = " +
          id +
          ", name = " +
          name +
          ", isSelect = " +
          isSelect
      );
      switch(category) {
        case PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA:
          if (recoginitionCheckList.value.list != null) {
            setSelectIngredient(recoginitionCheckList.value.list, id, isSelect);
          }
          break;
        case PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE:
          setSelectIngredient(favoriteList.value, id, isSelect);
          break;
        case PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED:
          setSelectIngredient(purChasedList.value, id, isSelect);
          break;
        case PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING:
          setSelectIngredient(rankingList.value, id, isSelect);
          break;
        default:
          selectIngredientFood(category, id, isSelect);
          break;
      }
    };

    const getIngredientDataList = (list: Array<IngredientData>, parentItem: MenuCategory, categoryName: string, saveFoodItems: SaveAddFoodItemData) => {
      const itemList = Array<SelectingIngredientListDataItem>();
      parentItem.children.forEach(item => {
        if (item.children != null && item.children.length >= 1) {
          getIngredientDataList(list, item, categoryName, saveFoodItems);
        } else {
          const food = new SelectingIngredientListDataItem();
          food.id = item.id;
          food.imageUrl = item.image;
          food.name = item.name;
          food.isSelect = false;
          if (saveFoodItems != null) {
            const saveFoodItem = saveFoodItems.getCategoryFoodItem(categoryName, parentItem.name, food.id);
            if (saveFoodItem != null) {
              food.isSelect = true;
            }
          }
          itemList.push(food);
        }
      });
      NativeClient.sendDebugLog(
        "PantryAddPage getIngredientDataList list.length=" + list.length
      );
      if (itemList.length != 0) {
        list.push(new IngredientData(parentItem.name, itemList));
      }
    };

    const categoryName = () => {
      NativeClient.sendDebugLog("categoryName");
      const categoryList: MenuCategories | null =
        store.getters["pantry/getMenuCategories"];
      const saveFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"];
      NativeClient.sendDebugLog(
        "PantryAddPage categoryName foodList=" + JSON.stringify(categoryList)
      );
      categoryNameList.value.length = 0;
      const isCamera = fridgeItemsJudege.value.isCamera();
      if (isCamera) {
        categoryNameList.value.push(PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA);
        selectCategoryName.value = PANTRY_ADD_CATEGORY_NAME_TYPE.CAMERA;
      } else {
        selectCategoryName.value = PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED;
      }
      categoryNameList.value.push(PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED);
      categoryNameList.value.push(PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING);
      categoryNameList.value.push(PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE);
      if (categoryList && categoryList.categories) {
        for (const item of categoryList.categories) {
          categoryNameList.value.push(item.name);
          const list = new Array<IngredientData>();
          getIngredientDataList(list, item, item.name, saveFoodItems);
          const ingredientCategoryData = new IngredientCategoryData(item.name, list);
          foodList.value.push(ingredientCategoryData);
        };
      }
      NativeClient.sendDebugLog(
        "PantryAddPage categoryName categoryNameList=" + JSON.stringify(categoryNameList)
      );
      NativeClient.sendDebugLog(
        "PantryAddPage categoryName foodList=" + JSON.stringify(foodList)
      );
      updateCategory();
      return categoryNameList.value;
    };

    const setFridgeItemsJudge = () => {
      // パントリー：冷蔵庫食材判定レスポンスを保持
      const result:FridgeItemsJudge = store.getters["pantry/getFridgeItemsJudge"];
      const saveFoodItems:SaveAddFoodItemData = store.getters["pantry/getSaveAddFoodItems"];
      NativeClient.sendDebugLog("PantryAddPage setFridgeItemsJudge result=" + result);
      const checkList = Array<SelectingCandidateIngredientListDataItem>();
      const list = Array<FoodItem>();
      if (result && result.newCandidateItems) {
        result.newCandidateItems.forEach(item => {
          const food = new SelectingCandidateIngredientListDataItem();
          // カメラのみオブジェクトIDを指定
          food.id = item.inferenceResultFoodId;
          food.imageUrl = item.icon;
          food.name = item.name;
          food.isSelect = false;
          food.isShowButton = true;
          food.foodId = item.ingredientId;
          food.applianceId = item.applianceId;
          food.defaultIngredientId = item.ingredientId;
          food.defaultName = item.name;
          if (saveFoodItems != null) {
            const saveFoodItem = saveFoodItems.getFridgeItem(food.id);
            if (saveFoodItem != null) {
              food.name = saveFoodItem.name;
              food.foodId = saveFoodItem.ingredientId;
              food.isSelect = saveFoodItem.isSelect;
              food.isSkip = saveFoodItem.isSkip;
              food.imageUrl = saveFoodItem.imageUrl;
              food.userNew = saveFoodItem.userNew;
            }
          }
          checkList.push(food);
        });
      }
      if (result && result.pantryFridgeItems) {
        result.pantryFridgeItems.forEach(item => {
            const food = new FoodItem(item.name, item.icon, item.ingredientId, null);
            list.push(food);
        });
      }
      recoginitionCheckList.value.list = checkList;
      recoginitionList.value.list = list;
      updateCameraListDisplay();
      fridgeItemsJudege.value.response = result;
    };

    const requestAddList = async () => {
      NativeClient.sendDebugLog("PantryAddPage requestUsedUpCheck");
      store.dispatch("common/startLoading");
      cameraApplianceId = "";
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        Promise.all([
          store.dispatch("pantry/getFridgeItemsJudge"),
          store.dispatch("pantry/getMenuCategories"),
        ]).then(result => {
          cameraApplianceId = PantryUtil.getCameraApplianceId();
          const judgeResult:FridgeItemsJudge = store.getters["pantry/getFridgeItemsJudge"];
          const isCamera = judgeResult != null && judgeResult.pantryJudgeKey != null;
          if (isCamera) {
            setFridgeItemsJudge();
            categoryName();
            store.dispatch("common/stopLoading");
          } else {
            Promise.all([store.dispatch("pantry/getPurChasedFoods")]).then(
            result => {
              setFridgeItemsJudge();
              setPurChased();
              categoryName();
              store.dispatch("common/stopLoading");
            });
          }
        });
      });
    };
    const execute = async () => {
      requestAddList();
    };

    // const retryGetPantry = () => {
    //   if (statusCheckScreen.value && statusCheckScreen.value.isApiExec()) {
    //     updateCheckDisplay();
    //   } else {
    //     execute();
    //   }
    //   closeDialog();
    // };

    const selectCategory = (index: number) => {
      updateDisplay();
      NativeClient.sendDebugLog("PantryAddPage select index = " + index);
      selectNo.value = index;
      if (index < categoryNameList.value.length) {
        selectCategoryName.value = categoryNameList.value[index];
      }
      NativeClient.sendDebugLog(
        "PantryAddPage selectCategoryName = " + selectCategoryName.value
      );
      // データチェック
      switch (selectCategoryName.value) {
        case PANTRY_ADD_CATEGORY_NAME_TYPE.PURCHASED:
          requestPurChased();
          break;
        case PANTRY_ADD_CATEGORY_NAME_TYPE.RANKING:
          requestRanking();
          break;
        case PANTRY_ADD_CATEGORY_NAME_TYPE.FAVORITE:
          requestFavorite();
          break;
      }
    };

    const clickBack = () => {
      // モーダル表示の場合は必要
      NativeClient.pageClose();
    };

    const clickRecoginitionTitle = async () => {
      // 起動前に連携機器のApplianceIdを取得する
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const applianceId = PantryUtil.getCameraApplianceId();
        NativeClient.sendDebugLog(
          "PantryAddPage clickRecoginitionTitle applianceId=" + applianceId
        );
        if (applianceId == null || applianceId == "") {
          return;
        }
        NativeClient.transitionPantryCamera();
      });
    };

    const requestCameraFood = async () => {
      NativeClient.sendDebugLog("PantryAddPage requestUsedUpCheck");
      NativeClient.sendDebugLog("PantryAddPage requestUsedUpCheck foodList=" + JSON.stringify(checkCameraFoodList.value));
      updateCheckDisplay();
      checkCamereSelectPosition.value = 0;
      isShowCheckCamera.value = true;
      NativeClient.showCloseButton(false);
    };
    const isCheckRecoginitionCheck = () => {
      let result = true;
      if (recoginitionCheckList.value.list != null && recoginitionCheckList.value.list.length != 0) {
        for (const item of recoginitionCheckList.value.list) {
          if (!item.isSelect) {
            result = false;
            break;
          }
        }
      }
      return result;
    };
    const isCheckRecoginition = (id: number) => {
      let result = false;
      if (recoginitionCheckList.value.list != null && recoginitionCheckList.value.list.length != 0) {
        for (const item of recoginitionCheckList.value.list) {
          if (item.id == id) {
            result = item.isSelect;
            break;
          }
        }
      }
      return result;
    };
    const setCheckFoodList = () => {
      NativeClient.sendDebugLog(
        "PantryAddPage setCheckFoodList"
      );
      if (fridgeItemsJudege.value.response == null
          || fridgeItemsJudege.value.response.newCandidateItems == null
          || fridgeItemsJudege.value.response.newCandidateItems.length == 0) {
        return;
      }
      const newCandidateItems = fridgeItemsJudege.value.response.newCandidateItems;
      NativeClient.sendDebugLog(
        "PantryAddPage setCheckFoodList newCandidateItems=" + JSON.stringify(newCandidateItems)
      );
      checkCameraFoodList.value = [];
      newCandidateItems.forEach(item => {
        const select = isCheckRecoginition(item.inferenceResultFoodId);
        if (!select) {
          // 未登録アイテムのみ対象
          checkCameraFoodList.value.push(new RequestRecognitionCandidateItem(item.inferenceResultFoodId, item.applianceId));
        }
      });
      NativeClient.sendDebugLog(
        "PantryAddPage setCheckFoodList checkCameraFoodList=" + JSON.stringify(checkCameraFoodList.value)
      );
      requestCameraFood();
    };
    const clickRecoginitionCheckTitle = () => {
      const checked = isCheckRecoginitionCheck();
      if (checked) {
        isShowCheckError.value = true;
        return;
      }
      setCheckFoodList();
    };
    // カメラ認識中（確認するボタン押下時）
    const clickRecoginitionCheckItem = (id: number | null, name: string) => {
      NativeClient.sendDebugLog(
        "PantryAddPage clickRecoginitionCheckItem id=" + id + " name=" + name
      );
      if (id == null) {
        return;
      }
      const item = fridgeItemsJudege.value.getNewCandidateItems(id);
      if (item == null) {
        return;
      }
      checkCameraFoodList.value = [];
      checkCameraFoodList.value.push(new RequestRecognitionCandidateItem(item.inferenceResultFoodId, item.applianceId));
      requestCameraFood();
    };

    const saveAddFoodItems = () => {
      const addItems = new SaveAddFoodItemData();
      addItems.fridgeItems = Array<SaveFridgeFoodItem>();
      addItems.purChasedItems = Array<SaveFoodItem>();
      addItems.rankingItems = Array<SaveFoodItem>();
      addItems.favoriteItems = Array<SaveFoodItem>();
      addItems.categoryItems = Array<SaveCategoryFoodItems>();
      if (recoginitionCheckList.value.list != null) {
        for (const item of recoginitionCheckList.value.list) {
          if (item.isSelect && item.id) {
            const data = new SaveFridgeFoodItem(item);
            addItems.fridgeItems.push(data);
          }
        }
      }
      for (const item of purChasedList.value) {
        if (item.isSelect && item.id) {
          addItems.purChasedItems.push(new SaveFoodItem(item));
        }
      }
      for (const item of rankingList.value) {
        if (item.isSelect && item.id) {
          addItems.rankingItems.push(new SaveFoodItem(item));
        }
      }
      for (const item of favoriteList.value) {
        if (item.isSelect && item.id) {
          addItems.favoriteItems.push(new SaveFoodItem(item));
        }
      }
      for (const category of foodList.value) {
        const genreItems = Array<SaveGenreFoodItems>();
        for (const genre of category.list) {
          const items = Array<SaveFoodItem>();
          for (const item of genre.list) {
            if (item.isSelect && item.id) {
              items.push(new SaveFoodItem(item));
            }
          }
          genreItems.push(new SaveGenreFoodItems(genre.title, items));
        }
        addItems.categoryItems.push(new SaveCategoryFoodItems(category.categoryName, genreItems));
      }
      NativeClient.sendDebugLog("PantryAddPage saveAddFoodItems addItems=" + JSON.stringify(addItems));
      store.dispatch("pantry/updateSaveAddFoodItems", addItems);
    }

    const onClickBottom = () => {
      NativeClient.sendDebugLog(
        "PantryAddPage onClickBottom"
      );
      saveAddFoodItems();
      router.push("/pantry-used-up-check");
    };

    const onClickCompliteButton = () => {
      isShowComplite.value = false;
      NativeClient.pageClose();
    };

    const recipeFoodList = computed(() => {
      const result = store.getters["pantry/getRecipeFoods"];
      NativeClient.sendDebugLog(
        "PantryPage recipeFoodList result=" + JSON.stringify(result)
      );
      if (result != null && result.foods != null) {
        return result.foods;
      }
      return null;
    });

    const requestRecipeFoods = async (keyword: string) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([store.dispatch("pantry/getRecipeFoods", keyword)]).then(
          result => {
            store.dispatch("common/stopLoading");
          }
        );
      });
    };

    const onFoodSearchClose = () => {
      isShowFoodSearch.value = false;
      if (!isShowCheckCamera.value) {
        NativeClient.showCloseButton(true);
      }
      if (!isCameraInputMode) {
        keyword.value = "";
      }
      isCameraInputMode = false;
      store.dispatch("pantry/updateRecipeFoods", null);
    };

    const onFoodSearch = (keyword: string) => {
      NativeClient.sendDebugLog("PantryAddPage onFoodSearch keyword=" + keyword);
      requestRecipeFoods(keyword);
    };

    const requestFood = async (payload: RegisterFood) => {
      store.dispatch("common/startLoading");
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiBaseParams = store.getters["common/getApiBaseParams"];
        Promise.all([store.dispatch("pantry/registerFood", payload)]).then(
          result => {
            NativeClient.sendDebugLog("PantryAddPage requestFood end");
            onFoodSearchClose();
            NativeClient.requestUpdatePantryList();
            store.dispatch("common/stopLoading");
            isShowAddComplite.value = true;
          }
        );
      });
    };

    const setRegisterFood = (food: FoodItem) => {
      const payload = new RegisterFood();
      const purchaseDate = DateUtil.getToday();
      if (food.foodId != DEFALT_FOOD_ID) {
        let expirationDate = null;
        let storageType = null;
        if (food.recipeFoodItem) {
          const shelfLifeItem = food.recipeFoodItem.getFoodShelfLive();
          if (shelfLifeItem != null && shelfLifeItem.shelfLife != null) {
            expirationDate = DateUtil.addDay(purchaseDate, shelfLifeItem.shelfLife);
            storageType = PantryUtil.convertServerStorageType(shelfLifeItem.shelfType);
          }
        }
        if (storageType == null) {
          storageType = PANTRY_DEFAULT_STORAGE_TYPE;
        }
        payload.setFoodId(food.foodId, purchaseDate, expirationDate, storageType);
      } else {
        payload.setManual(food.name, purchaseDate);
      }
      NativeClient.sendDebugLog("PantryAddPage setRegisterFood payload=" + JSON.stringify(payload));
      requestFood(payload);
    };


    const showSearchView = () => {
      inputKeyword.value = keyword.value;
      isCameraInputMode = false;
      if (keyword.value != "") {
        // 検索キーワード入力済みであれば、食材検索
        onFoodSearch(keyword.value);
        updateKeyword();
        isShowFoodSearch.value = true;
      }
    };

    const onClickSearch = () => {
      if (keyword.value == "" || keyword.value == null) {
        return;
      }
      // チェックボックス未選択時
      NativeClient.showCloseButton(false);
      showSearchView();
    };

    const styleBottomButton = computed(() => {
      const empty = isSelectEmpty();
      return {
         background: !empty ? `rgb(0,0,0)` : `rgb(0,0,0,0.3)`
      };
    });

    const closeCameraCheck = () => {
      checkCamereSelectPosition.value = 0;
      checkCameraFoodList.value = [];
      statusCheckScreen.value.clear();
    };

    const onClickCheckCameraClose = () => {
      if (isFoodTimerExec.value) {
        NativeClient.sendDebugLog("PantryAddPage onClickCheckCameraClose timer");
        return;
      }
      closeCameraCheck();
      isShowCheckCamera.value = false;
      NativeClient.showCloseButton(true);
    };

    const styleBottomButtonText = computed(() => {
      const empty = isSelectEmpty();
      return { color: !empty ? `rgb(255,255,255)` : `rgb(255,255,255,0.6)` };
    });

    const onClickCheckCameraSkip = () => {
      if (isFoodTimerExec.value) {
        NativeClient.sendDebugLog("PantryAddPage onClickCheckCameraSkip timer");
        return;
      }
      if (checkCamereSelectPosition.value + 1 < checkCameraFoodList.value.length ) {
        checkCamereSelectPosition.value++;
        updateCheckDisplay();
      } else {
        onClickCheckCameraClose();  
      }
    };

    const nextCheckCamera = (food: FoodItem) => {
      NativeClient.sendDebugLog(
        "PantryAddPage nextCheckCamera position=" + checkCamereSelectPosition.value + " food=" + JSON.stringify(food)
      );
      const end = checkCamereSelectPosition.value + 1 == checkCameraFoodList.value.length;
      if (recoginitionCheckList.value.list != null) {
        for (const item of recoginitionCheckList.value.list) {
          if (food && item.id == food.inferenceResultFoodId) {
            item.isSelect = true;
            item.imageUrl = food.icon ? food.icon : "";
            item.name = food.name ? food.name : "";
            item.foodId = food.foodId;
            item.userNew = food.userNew;
            updateCameraListDisplay();
            break;
          }
        }
      }
      isCameraInputMode = false;
      isShowFoodSearch.value = false;
      store.dispatch("pantry/updateRecipeFoods", null);
      isFoodTimerExec.value = false;
      if (end || food &&food.inferenceResultFoodId == DEFALT_FOOD_ID) {
        onClickCheckCameraClose();
      } else {
        onClickCheckCameraSkip();
      }
    }

    const setCheckFoodTimer = (foodItem: FoodItem) => {
      NativeClient.sendDebugLog("PantryAddPage setCheckFoodTimer");
      cancelCheckFoodTimer();
      checkTimerId = window.setTimeout(() => {
        NativeClient.sendDebugLog("PantryAddPage setCheckFoodTimer timeout");
        checkTimerId = -1;
        nextCheckCamera(foodItem);
      }, FOOD_TIMER);
    };
    const onClickCheckCameraFood = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryAddPage onClickCheckCameraFood position=" + checkCamereSelectPosition.value + " inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      if (isFoodTimerExec.value) {
        NativeClient.sendDebugLog("PantryAddPage onClickCheckCameraFood timer");
        return;
      }
      isFoodTimerExec.value = true;
      const foodItem = new FoodItem(data.name, data.imageUrl, data.ingredientId, null);
      foodItem.inferenceResultFoodId = inferenceResultFoodId;
      foodItem.userNew = data.userNew;
      setCheckFoodTimer(foodItem);
    };

    const onClickCheckCameraInput = (inferenceResultFoodId: number, data: CandidateInfo) => {
      NativeClient.sendDebugLog(
        "PantryAddPage onClickCheckCameraInput position=" + checkCamereSelectPosition.value + " inferenceResultFoodId=" + inferenceResultFoodId + " data=" + JSON.stringify(data)
      );
      if (isFoodTimerExec.value) {
        NativeClient.sendDebugLog("PantryAddPage onClickCheckCameraInput timer");
        return;
      }
      inputInferenceResultFoodId = inferenceResultFoodId;
      inputCandinateData.value = data;
      inputKeyword.value = "";
      updateKeyword();
      isCameraInputMode = true;
      isShowFoodSearch.value = true;
    };

    const onClickCheckCameraBack = () => {
      if (isFoodTimerExec.value) {
        NativeClient.sendDebugLog("PantryAddPage onClickCheckCameraCancel timer");
        return;
      }
      if (checkCamereSelectPosition.value - 1 >= 0) {
        checkCamereSelectPosition.value--;
        updateCheckDisplay();
      }
    };

    const onSelectFood = (food: FoodItem) => {
      NativeClient.sendDebugLog("PantryAddPage onSelectFood isShowCheckCamera=" + isShowCheckCamera.value + " food=" + JSON.stringify(food));
      if (isShowCheckCamera.value) {
        // 画像認識中のテキスト入力中
        checkFoodItem.value = food;
        if (inputInferenceResultFoodId != DEFALT_FOOD_ID) {
          food.inferenceResultFoodId = inputInferenceResultFoodId;
          if (inputCandinateData.value) {
            food.userNew = inputCandinateData.value.userNew;
          }
        }
        inputInferenceResultFoodId = DEFALT_FOOD_ID;
        inputCandinateData.value = new CandidateInfo();
        nextCheckCamera(food);
      } else {
        setRegisterFood(food);
      }
    };

    const onClickAddCompilteNegative = () => {
      isShowAddComplite.value = false;
      if (isInputMode) {
        NativeClient.showCloseButton(false);
        showSearchView();
      }
      isInputMode = false;
    };

    const onClickCheckeErrorNegative = () => {
      isShowCheckError.value = false;
    };

    const onStatusCameraCheck = (status: StatusCameraCheck) => {
      NativeClient.sendDebugLog(
        "PantryAddPage onStatusCameraCheck status=" + JSON.stringify(status)
      );
      statusCheckScreen.value = status;
    };

    const isShowList = () => {
      return recoginitionCheckList.value.list != null && recoginitionList.value.list != null
    };

    const handleEnter = () => {
      if (textInput.value != undefined) {
        textInput.value.blur();
      }
    };

    const selectCheckCameraImage = (fileName: string) => {
      NativeClient.sendDebugLog(
        "PantryAddPage selectCheckCameraImage fileName=" + fileName
      );
      NativeClient.transitionPantryZoom(fileName);
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(async () => {
      execute();
    });

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onUnmounted(async () => {
      // 画面から離れた場合
    });

    const closeError = () => {
      closeDialog();
    };

    return {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      clickBack,
      updateDisplayKey,
      selectCategory,
      onSelectIngredient,
      categoryName,
      selectNo,
      categoryNameList,
      PANTRY_ADD_CATEGORY_NAME_TYPE,
      isSelect,
      purChasedList,
      rankingList,
      favoriteList,
      updateCategoryKey,
      foodList,
      selectCategoryName,
      recoginitionCheckList,
      recoginitionList,
      clickRecoginitionCheckTitle,
      clickRecoginitionTitle,
      clickRecoginitionCheckItem,
      onClickBottom,
      isShowComplite,
      onClickCompliteButton,
      isShowFoodSearch,
      onClickSearch,
      recipeFoodList,
      onFoodSearchClose,
      onFoodSearch,
      onSelectFood,
      styleBottomButton,
      styleBottomButtonText,
      isShowCheckCamera,
      checkCamereSelectPosition,
      updateCheckDisplayKey,
      onClickCheckCameraFood,
      onClickCheckCameraInput,
      onClickCheckCameraBack,
      onClickCheckCameraSkip,
      onClickCheckCameraClose,
      checkCameraFoodList,
      updateCameraListDisplayKey,
      isShowAddComplite,
      onClickAddCompilteNegative,
      updateListCheckKey,
      isFoodTimerExec,
      keywordComputed,
      inputKeyword,
      updateKeywordKey,
      isShowCheckError,
      onClickCheckeErrorNegative,
      isShowList,
      textInput,
      handleEnter,
      isSelectEmpty,
      onStatusCameraCheck,
      selectCheckCameraImage,
      closeError,
      ERROR_BUTTON_LABEL
    };
  }
});
